import React from "react";
import { Helmet } from "react-helmet-async";

export default function Terms() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Terms & Conditions | Aerzen Air™</title>
        <meta
          name="description"
          content="Read the Terms & Conditions governing the use of Aerzen Air™ website, products, pre-booking, and related services."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/terms"
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>

      <p className="text-gray-700 mb-4">
        Welcome to AERZEN AIR™. By accessing or using our website, you agree to
        comply with and be bound by the following terms and conditions.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Product Information</h2>
      <p className="text-gray-700 mb-4">
        All product specifications, images, and performance indicators are
        indicative and may vary based on room conditions, pollution levels, and
        usage patterns.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Pre-Booking</h2>
      <p className="text-gray-700 mb-4">
        Pre-booking amounts are adjustable against the final invoice. Delivery
        timelines are indicative and subject to manufacturing and logistics
        readiness.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Limitation of Liability</h2>
      <p className="text-gray-700 mb-4">
        AERZEN AIR™ shall not be liable for any indirect, incidental, or
        consequential damages arising from the use of this website or products.
      </p>

      <p className="text-gray-500 text-sm mt-8">
        Last updated: {new Date().toLocaleDateString("en-IN")}
      </p>
    </main>
  );
}
